import { render, staticRenderFns } from "./SubjectsUpdate.vue?vue&type=template&id=335f2444&scoped=true"
import script from "./SubjectsUpdate.vue?vue&type=script&lang=js"
export * from "./SubjectsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f2444",
  null
  
)

export default component.exports